import React from 'react';
import { useDispatch } from 'react-redux';
import Chart from '@components/overview-dashboard/common/chart/Chart';
import { setSelectedKPI } from '@store/overviewDashboard/base/actions';
import { humanize } from '@utils';
import humanizeValue from '@utils/humanizeUtil';
import { TOOLTIP_LABEL_FORMAT } from '@components/common/Charts/utils';
import moment from 'moment-timezone';
import { getMetricUnitText, getMetricMetaByKey, getMetricOvbDisplayName } from '@utils/metrics';
import {
  MetricCardWrapper,
  MetricNameWrapper,
  MetricValueWrapper,
  MetricChartWrapper,
  MetricUnitWrapper,
  MetricValue,
} from './styled';

const MetricCard = ({ metric, chartData, selected }) => {
  const dispatch = useDispatch();
  const chartOption = chartData;
  const metricInfo = getMetricMetaByKey({ metricKey: metric });
  const ovbDisplayName = getMetricOvbDisplayName({ metricKey: metric });
  const metricValue = chartData ? chartData._aggregate : '';
  const value = humanizeValue(metricValue, metric, metricInfo.unit);
  const renderChart = (chartOption) => {
    const height = '45px';
    const width = '100%';
    if (chartOption) {
      chartOption.tooltip.formatter = tooltipFormatter;
      return <Chart option={chartOption} height={height} width={width} />;
    }
  };

  const tooltipFormatter = (params) => {
    const unit = '%';
    const value = params[0].data;
    const yVal = humanize(value[1], unit);
    const xVal = moment(value[0]).format(TOOLTIP_LABEL_FORMAT);
    return `${xVal}<br/>${ovbDisplayName} - <b>${yVal}${getMetricUnitText(unit)}</b>`;
  };

  const handleClick = () => {
    if (selected) {
      dispatch(setSelectedKPI('StreamingPerformanceIndex'));
    } else {
      dispatch(setSelectedKPI(metric));
    }
  };

  // {renderChart(chartData)}
  return (
    <MetricCardWrapper
      id={ovbDisplayName}
      className={selected ? 'active' : ''}
      selected={selected}
      onClick={handleClick}
    >
      <MetricValueWrapper>
        <MetricValue>{value.humanizedNumber}</MetricValue>
        <MetricUnitWrapper>{value.humanizedUnit}</MetricUnitWrapper>
      </MetricValueWrapper>
      <MetricNameWrapper>{ovbDisplayName}</MetricNameWrapper>
      <MetricChartWrapper>{renderChart(chartOption)}</MetricChartWrapper>
    </MetricCardWrapper>
  );
};

export default React.memo(MetricCard);
